export const PERSONAL_DETAILS_FORM = {
  title: '',
  first_name: '',
  middle_name: '',
  last_name: '',
  date_of_birth: '',
  source_of_funds: '',
  intended_use_of_account: null,
  intended_use_of_account_meta: '',
  nationality: '',
  occupation: null,
  employment_status: '',
  is_pep: false,
  net_worth_value: '',
  is_dual_citizen: '',
  industry_type: '',
  mobile_country_code: '',
  mobile_number: '',
  postcode: '',
  street_number: '',
  street_type: '',
  state: '',
  street_name: '',
  suburb: '',
  building_name: '',
  unit_number: '',
  block_number: '',
  city: '',
  building_number: '',
  district: '',
  address1: '',
  address2: '',
  floor_number: '',
  is_promotion_subscription: false,
  is_aml_check_consent: true,
  email: '',
  street: '',
  province: '',
  gender: '',
  fiscal_code: '',
  is_mailing_address_diff: false,
  employment_status_meta: '',
  nature_of_self_employment: '',
  is_permanent_sg_resident: '',
  destination_of_fund: '',
  expected_monthly_volume: '',
  residential: {
    postcode: '',
    street_number: '',
    street_type: '',
    state: '',
    street_name: '',
    suburb: '',
    building_name: '',
    unit_number: '',
    block_number: '',
    city: '',
    building_number: '',
    district: '',
    address1: '',
    address2: '',
    floor_number: '',
    street: '',
    province: ''
  },
  mailing: {
    postcode: '',
    street_number: '',
    street_type: '',
    state: '',
    street_name: '',
    suburb: '',
    building_name: '',
    unit_number: '',
    block_number: '',
    city: '',
    building_number: '',
    district: '',
    address1: '',
    address2: '',
    floor_number: '',
    street: '',
    province: ''
  }
};
